<template>
  <div class="panel-body w-100">
      <div class="new-event">
          <div class="user-info">
              <div class="avatar">
                  <img :src="event_data._source.creator.avatar">
              </div>
              <div class="info">
                  <div class="user-name-info">
                      <font-awesome-icon v-if="event_data._source.creator.sex === 1" :icon="['fa', 'mars']" size="lg"/>
                      <font-awesome-icon v-else-if="event_data._source.creator.sex === 2" :icon="['fa', 'venus']" />
                      <a v-if="current_user.admin_level > 10" :href="`https://evo.skylove.su/users/user/edit?id=${event_data._source.creator.id}`" target="_blank">
                           <span class="info-name">
                               {{ event_data._source.creator.name }}
                               {{ event_data._source.creator.age ? `(${event_data._source.creator.age})` : '' }}
                          </span>
                      </a>
                      <span v-else class="info-name">
                          {{ event_data._source.creator.name }}
                          {{ event_data._source.creator.age ? `(${event_data._source.creator.age})` : '' }}
                      </span>
                  </div>
                  <div v-if="event_data._source.creator.city" class="info-country">Страна: <span>{{ event_data._source.creator.country }}</span></div>
                  <div v-if="event_data._source.creator.city" class="info-city">Город: <span>{{ event_data._source.creator.city }}</span></div>
                  <div class="events-count">Событий: <span>1</span></div>
              </div>
          </div>
          <div class="event-image d-none d-xl-block">
              <img :src="event_data._source.banner_image">
          </div>
          <div class="event-cat">
              <ul class="list-group list-group-flush">
                  <li v-if="event_data._source.titles.title[event_data._source.creator.locale]" class="list-group-item">
                      {{ event_data._source.titles.title[event_data._source.creator.locale] }}
                  </li>
                  <li v-if="event_data._source.my_type && event_data._source.new_subtitle.trim()" class="list-group-item li-newsubtitle">
                      {{ event_data._source.new_subtitle }}
                      <span @click="editEventTitle(event_data)" class="badge badge-primary badge-pill edit-subtitle-icon" title="Изменить">
                          <font-awesome-icon :icon="['fas', 'pencil-alt']"/>
                      </span>
                  </li>
                  <li v-else-if="event_data._source.titles.subtitle[event_data._source.creator.locale]" class="list-group-item li-subtitle">
                      {{ event_data._source.titles.subtitle[event_data._source.creator.locale] }}
                  </li>
              </ul>
          </div>
          <div class="event-description">
              <h5 class="title-block">Описание</h5>
              <div v-if="event_data._source.description" class="description">
                  <div>{{ event_data._source.description ? event_data._source.description : 'Описание отсутствует!' }}</div>
                  <font-awesome-icon @click="editEventDescription(event_data)" :icon="['fas', 'pencil-alt']"/>
              </div>
          </div>
          <div class="event-buttons">
              <button @click="checkStatusConfirm(event_data, 1)" class="btn btn-event-approve" title="Разрешить"></button>
              <button @click="checkStatusConfirm(event_data, 2)" class="btn btn-event-reject" title="Отклонить"></button>
              <button class="btn btn-xs"></button>
          </div>
      </div>
  </div>

</template>

<script>
import Swal from 'sweetalert2'
export default {
  name: "StatusEventsComponent",
  props: {
    event_data: {
      type: Object,
      default() {
        return {};
      },
    },
    current_user: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
        limitSubTitle: 50,
        limitDescription: 300,
    }
  },
  computed: {
    langs() {
      return this.$store.getters.langs;
    },
    events() {
      return this.$store.getters.events;
    },
  },

  methods: {
      editEventTitle(event) {
          Swal.fire({
              title: 'Редактировать название',
              input: 'text',
              inputValue: event._source.new_subtitle,
              inputAttributes: {
                  autocapitalize: 'off'
              },
              showCancelButton: true,
              confirmButtonText: 'Сохранить',
              cancelButtonText: 'Отмена',
              showLoaderOnConfirm: true,
              preConfirm: (newTitle) => {
                  if (!this.checkPermissibleLength(newTitle, this.limitSubTitle, `Название не должно быть длиннее ${this.limitSubTitle} символа(-ов)!`)) {
                      return;
                  }

                  const subtitleObj = {};

                  this.langs.map(lang => {
                      subtitleObj[lang] = lang === event._source.creator.locale ? newTitle : (event._source.titles.subtitle[lang] ? event._source.titles.subtitle[lang] : "");
                      return lang;
                  });

                  this.$store.commit('updateEventById', {
                      id: event._id,
                      new_subtitle: newTitle,
                      titles: {
                          title: event._source.titles.title,
                          title_id: event._source.titles.title_id,
                          subtitle: subtitleObj,
                          subtitle_key: event._source.titles.subtitle_key,
                      },
                  });

              },
          });
      },
      editEventDescription(event) {
          Swal.fire({
              title: 'Редактировать описание',
              input: 'textarea',
              inputValue: event._source.description,
              inputAttributes: {
                  autocapitalize: 'off'
              },
              width: 500,
              showCancelButton: true,
              confirmButtonText: 'Сохранить',
              cancelButtonText: 'Отмена',
              showLoaderOnConfirm: true,
              preConfirm: (newDesc) => {
                  if (!this.checkPermissibleLength(newDesc, this.limitDescription, `Описание не должно быть длиннее ${this.limitDescription} символа(-ов)!`)) {
                      return;
                  }
                  this.$store.commit('updateEventById', { id: event._id, description: newDesc });
              },
          });
      },
      checkStatusConfirm(e, status = 1) {
          Swal.fire({
              title: status === 1 ? 'Одобрить событие?' : (status === 2 ? 'Отклонить событие?' : ""),
              text: `Данное событие будет ${status === 1 ? 'одобрено' : (status === 2 ? 'отклонено' : '')}.`,
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Да',
              cancelButtonText: 'Нет',
          })
              .then(result => {
                  if (!result.value) return;
                  this.checkStatus(e, status);
              })
      },
      async checkStatus(e, status = 1) {

          if (status && !this.checkPermissibleLength(e._source.titles.new_subtitle, this.limitSubTitle, `Название не должно быть длиннее ${this.limitSubTitle} символа(-ов)!`)) {
              return;
          }

          if (status && !this.checkPermissibleLength(e._source.description, this.limitDescription, `Описание не должно быть длиннее ${this.limitDescription} символа(-ов)!`)) {
              return;
          }

          const event = JSON.parse(JSON.stringify(e));

          event._source.status = status;
          event.hide = true;

          const user = this.current_user;

          setTimeout(() => {
              this.$store.commit('setEvents', this.events.filter(ev => ev._id !== event._id))
          }, 500);

          await this.$store.dispatch('updateEventByModerator', {
              event,
              request: true,
              admin_id: (user && user.admin_id) ? user.admin_id : null,
          });

          setTimeout(() => {
              this.getEvents();
          }, 1000);
      },
      checkPermissibleLength(str = '', length = 255, error = null) {
          if (str.length > length) {

              if (!error) {
                  return false;
              }

              setTimeout(() => {
                  Swal.fire({
                      type: 'error',
                      title: error,
                  });
              }, 300);

              return false;
          }

          return true;
      }
  }
}
</script>

<style scoped>
.panel-body {
  padding: 0 15px;
  width: 100%;
}
.panel-body .new-event {
  height: 160px;
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  padding: 10px 0;
  overflow-y: hidden;
}
.panel-body .new-event img {
  display: block;
  margin: 0 auto;
  border-radius: 5px;
}
.panel-body .new-event .title-block {
  border-bottom: 1px solid #eee;
  padding-bottom: 20px;
  margin-top: 0;
}
.panel-body .new-event .user-info {
  flex-basis: 20%;
  display: flex;
}
/*@media only screen and (max-width: 1380px) {*/
/*  .panel-body .new-event .user-info {*/
/*    display: none;*/
/*  }*/
/*}*/
.panel-body .new-event .user-info .avatar {
  flex-basis: auto;
}
.new-event .user-info .avatar img {
  display: block;
  height: 140px;
  width: 140px;
  border-radius: 5px;
}
.panel-body .new-event .user-info .info {
  flex-basis: 60%;
  padding-left: 15px;
  overflow: hidden;
}
.panel-body .new-event .user-info .info .user-name-info {
  font-size: 1.1em;
}
.panel-body .new-event .user-info .info .user-name-info .info-name {
  font-weight: 600;
}
.panel-body .new-event .user-info .info .user-name-info .fa-mars {
  color: #57c8f2;
}
.panel-body .new-event .user-info .info .user-name-info .fa-venus {
  color: #ff6c60;
}
.panel-body .new-event .user-info .info .info-country, .panel-body .new-event .user-info .info .info-city {
  color: #acb3c3;
}
.panel-body .new-event .user-info .info .info-country span, .panel-body .new-event .user-info .info .info-city span {
  color: #717171;
}
.panel-body .new-event .user-info .info .events-count {
  color: #acb3c3;
  margin: 10px 0;
}
.panel-body .new-event .user-info .info .events-count span {
  color: #3689cb;
}
.panel-body .new-event .user-info .info .social-links li {
  display: inline-block;
}
.panel-body .new-event .user-info .info .social-links li a {
  background: #EFF0F4;
  margin: 2px 0;
  width: 25px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  display: inline-block;
  border-radius: 5px;
  color: #7A7676;
}
.panel-body .new-event .event-image {
  flex-basis: auto;
  padding: 0 5px;
}
.panel-body .new-event .event-image img {
  height: 140px;
  width: auto;
  display: block;
}
.panel-body .new-event .event-cat {
  flex-basis: 20%;
  padding: 0 5px;
}
@media only screen and (max-width: 1380px) {
  .panel-body .new-event .event-cat {
    flex-basis: 30%;
  }
}
.panel-body .new-event .event-cat .title-block {
  color: #66c7bd;
  padding: 0;
  margin: 0;
}
.panel-body .new-event .event-cat .title-block span {
  font-size: 0.66em;
  color: #b3b9c9;
}
.panel-body .new-event .event-cat .list-group {
  margin-top: 5px;
}
.panel-body .new-event .event-cat .list-group .list-group-item {
  border-right: none;
  border-left: none;
  border-top: none;
  border-bottom: 1px solid #eee;
  border-radius: 0;
  margin-bottom: 0;
  padding: 7px 0;
}
.panel-body .new-event .event-cat .list-group .list-group-item:first-child {
  padding: 8px 0;
}
.panel-body .new-event .event-cat .list-group .list-group-item .badge {
  background-color: #36a3ce;
  border-radius: 2px;
  padding: 3px;
  cursor: pointer;
}
.panel-body .new-event .event-cat .list-group .li-subtitle {
  color: #66c7bd;
  font-size: 1.1em;
}
.panel-body .new-event .event-cat .list-group .li-newsubtitle {
  color: #36a3ce;
  font-size: 1.1em;
  overflow-x: hidden;
}
.panel-body .new-event .event-description {
  flex-basis: 34%;
  padding: 0 10px;
}
@media only screen and (max-width: 1380px) {
  .panel-body .new-event .event-description {
    flex-basis: 48%;
  }
  .panel-body .new-event .event-description .description {
    font-size: 0.9em;
  }
}
.panel-body .new-event .event-description .description {
  height: 70px;
  overflow-y: hidden;
  display: flex;
}
.panel-body .new-event .event-description .description div {
  flex-basis: 95%;
  max-width: 330px;
  overflow-x: hidden;
  white-space: pre-wrap;
  text-overflow: ellipsis;
}
.panel-body .new-event .event-description .description svg.fa-pencil-alt {
  margin-left: auto;
  height: 1.3125rem;
  width: 1.3125rem;
  padding: 4px;
  background-color: #959595;
  color: #fff;
  border-radius: 2px;
  cursor: pointer;
}
.panel-body .new-event .event-buttons {
  flex-basis: auto;
  flex-direction: column;
  display: flex;
  margin-left: auto;
}
.panel-body .new-event .event-buttons .btn {
  width: 40px;
  height: 55px;
  margin-bottom: 2px;
  margin-left: auto;
}
.panel-body .new-event .event-buttons .btn:not(:last-child) {
  background-size: 100% 100%;
}
.panel-body .new-event .event-buttons .btn-event-approve {
  background: url(https://evo.skylove.su/images/approve_event.png);
}
.panel-body .new-event .event-buttons .btn-event-reject {
  background: url(https://evo.skylove.su/images/reject_event.png);
}
.panel-body .new-event .event-buttons .btn:last-child {
  height: 20px;
  width: 35px;
  margin-top: 2px;
  margin-right: 2px;
  background-color: #fff;
  border: 1px solid #eee;
}
.list-group-item > .badge {
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/users/StatusEventsComponent.vue